import React, { useState, useRef } from 'react';
import { PlayIcon } from 'lucide-react';
export function PhoneVideoPlayer() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const handlePlay = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
        setIsPlaying(false);
      } else {
        videoRef.current.play();
        setIsPlaying(true);
      }
    }
  };
  return <div className="relative mx-auto w-[280px] shrink-0 overflow-hidden rounded-[3rem] border-[8px] border-slate-900 bg-black shadow-2xl shadow-emerald-900/20 sm:w-[300px]" data-id="element-1">
      {/* Dynamic Island */}
      <div className="absolute left-1/2 top-3 z-20 h-7 w-24 -translate-x-1/2 rounded-full bg-black" data-id="element-2"></div>

      <div className="relative aspect-[9/19.5] w-full overflow-hidden rounded-[2.25rem] bg-slate-900" data-id="element-3">
        <video ref={videoRef} src="https://cdn.magicpatterns.com/uploads/e9tmij62t2doYhn9W2521Z/pagina.mov" className="h-full w-full object-cover" playsInline onEnded={() => setIsPlaying(false)} onClick={handlePlay} data-id="element-4" />

        {!isPlaying && <button onClick={handlePlay} className="absolute inset-0 z-10 flex items-center justify-center bg-black/30 transition-colors hover:bg-black/40" aria-label="Reproducir video" data-id="element-5">
            <div className="flex h-16 w-16 items-center justify-center rounded-full bg-white/95 text-emerald-950 shadow-lg backdrop-blur-sm transition-transform hover:scale-105" data-id="element-6">
              <PlayIcon className="ml-1 h-8 w-8" fill="currentColor" data-id="element-7" />
            </div>
          </button>}
      </div>
    </div>;
}